import type { MeResponse } from '../types'

/**
 * The app's own row: the company mark, and whose account this is.
 *
 * The mark is Orovim's, not the product's: the row says "Orovim", and the
 * reply bubble next to it was a second logo for a name that isn't its own.
 *
 * The ticket does not belong here. It changes with every ticket the agent
 * opens, while everything in this row changes about once a year, and putting
 * the two together made a bar that was half chrome and half content.
 *
 * The connection state rides on the avatar: a green ring while the host is
 * talking to us. The title says it in words, since a ring alone is not
 * readable.
 */
export function AppHeader({
  me,
  status,
  statusLabel,
  onAvatar,
}: {
  me: MeResponse | null
  /** Only the ticket panel has a host to be connected to. */
  status?: string
  statusLabel?: string
  /** Where the avatar goes: settings from the panel, the profile from within. */
  onAvatar: () => void
}) {
  const who = me?.displayName || me?.email || 'Signed in'
  const connected = status === 'connected'
  const where = statusLabel ? `${who} · ${statusLabel}` : who

  return (
    <header className="app-header">
      {/* The same mark the extension shows in Desk's own panel chrome, so the
          two do not look like different apps stacked on each other. */}
      <img className="header-logo" src="/orovim.png" alt="" />
      <span className="header-name">Orovim</span>

      <button
        className={connected ? 'header-avatar-btn live' : 'header-avatar-btn'}
        onClick={onAvatar}
        title={where}
        aria-label={where}
      >
        {me?.photoURL ? (
          <img className="header-avatar" src={me.photoURL} alt="" />
        ) : (
          <span className="header-avatar header-blank" aria-hidden="true">
            {who.slice(0, 1).toUpperCase()}
          </span>
        )}
      </button>
    </header>
  )
}
